import React from 'react';

import Video from '@components/pages/PageTemplates/Blocks/VideoBlock/Video';

import { MOMENT_THAT_MATTERS_POSTER_IMAGE_URL, MOMENT_THAT_MATTERS_VIDEO_URL } from './constant';

const MomentThatMatter = () => {
  return (
    <article className="mt-112 px-12 pb-80">
      <div className="m-auto max-w-container-lg">
        <h2 className="m-0 border-0 border-b border-solid border-grayscale-beige pb-32 font-suisse-screen text-headline-lg sm:text-headline-alt-lg dark:border-grayscale-gray">
          Moment that matters
        </h2>
        <div className="aspect-[16/9] w-full md:px-72">
          <Video
            content={{ src: MOMENT_THAT_MATTERS_VIDEO_URL }}
            config={{
              autoplay: false,
              controls: true,
              playsinline: true,
              poster: MOMENT_THAT_MATTERS_POSTER_IMAGE_URL,
            }}
            maxWidth="w-full"
          />
        </div>
      </div>
    </article>
  );
};

export default MomentThatMatter;
